import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const mesesOrden = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const colores = [
  "rgba(255, 99, 132, 0.7)",
  "rgba(54, 162, 235, 0.7)",
  "rgba(255, 206, 86, 0.7)",
  "rgba(75, 192, 192, 0.7)",
  "rgba(153, 102, 255, 0.7)",
  "rgba(255, 159, 64, 0.7)",
  "rgba(100, 255, 100, 0.7)",
];

const GraficoVentasOficial = ({ datos }) => {
  const limpiarMonto = (valor) => {
    if (typeof valor !== "string") valor = String(valor);
    return parseFloat(valor.replace(/[$,]/g, "")) || 0;
  };

  const datosPorAnio = {};

  datos.forEach(({ FECHA, TOTAL }) => {
    if (!FECHA || typeof FECHA !== "string") return;

    const partes = FECHA.split("-");
    if (partes.length !== 3) return;

    const mes = parseInt(partes[1]) - 1; // 0-indexed
    const anio = parseInt(partes[2]);

    const monto = limpiarMonto(TOTAL);
    if (!datosPorAnio[anio]) datosPorAnio[anio] = Array(12).fill(0);
    datosPorAnio[anio][mes] += monto;
  });

  const datasets = Object.entries(datosPorAnio).map(([anio, data], i) => ({
    label: anio,
    data,
    backgroundColor: colores[i % colores.length],
  }));

  const chartData = {
    labels: mesesOrden,
    datasets,
  };

  return (
    <div className="bg-white p-4 rounded shadow mb-4">
      <h3 className="text-xl font-semibold mb-4 text-center">Ventas por Mes</h3>
      <div className="w-full h-[400px]">
        <Bar
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  callback: (value) => "$" + value.toLocaleString("es-CL"),
                },
              },
            },
            plugins: {
              legend: { position: "top" },
            },
          }}
        />
      </div>
    </div>
  );
};

export default GraficoVentasOficial;
